import React, { Component, Fragment } from "react";
import { CommandBarButton } from "office-ui-fabric-react";
import Table, { TableColumn } from "./Table";
import ProcessorComparisonResult from "../models/ProcessorComparisonResult";
import { ProcessorItem } from "../models/MailroomProcessorItem";
import ProcessorItemsViewer from "./mailroom/ProcessorItemsViewer";
import {ProcessorDifferencesViewer} from "./ProcessorDifferencesViewer";
import {Link} from "react-router-dom";
import ComparisonBreakdownCharts from "./mailroom/comparison/ComparisonBreakdownCharts";


export interface ProcessorOutputComparisonViewerProps {
    result: ProcessorComparisonResult;
}

export interface ProcessorOutputComparisonViewerState {
    itemsTitle?: string;
    items?: ProcessorItem[]
    showDifferences: boolean;
    showCharts: boolean;
}

export default class ProcessorDiffViewer extends Component<ProcessorOutputComparisonViewerProps, ProcessorOutputComparisonViewerState> {
    static displayName = ProcessorDiffViewer.name;

    private static columns: TableColumn[] = [
        { title: "Added", propertyPath: "summary.addedCount", flex: 1 },
        { title: "Removed", propertyPath: "summary.removedCount", flex: 1 },
        { title: "Changed", propertyPath: "summary.changedCount", flex: 1 },
        { title: "Total", propertyPath: "summary.total", flex: 1 },
    ];

    constructor(props: ProcessorOutputComparisonViewerProps) {
        super(props);

        this.state = {
            itemsTitle: undefined,
            items: undefined,
            showDifferences: false,
            showCharts: false
        };
    }

    public componentDidMount() {
    }
    
    public render() {

        return (
            <Fragment>
                
                {this.state.showCharts ?  <ComparisonBreakdownCharts breakdown={this.props.result.summary.breakdown} onCloseClicked={() => this.setState({showCharts: false})}/> : null}
                
                <Table
                    title={"Comparison Results"}
                    items={[this.props.result]}
                    columns={ProcessorDiffViewer.columns}>


                    <CommandBarButton
                        iconProps={{ iconName: "DonutChart" }}
                        text="Chart Results"
                        onClick={() => {
                            this.setState({
                                showCharts: true
                            });
                        }}
                    />
                    
                    <Link to={`/cdb-admin/mailroom/salamander/${this.props.result.tenantId}/${this.props.result.schoolCode}/process/${this.props.result.summary.firstInstanceId}`} target="_blank">
                        <CommandBarButton
                            iconProps={{ iconName: "OpenInNewTab" }}
                            text="Open First"
                        />
                    </Link>

                    <Link to={`/cdb-admin/mailroom/salamander/${this.props.result.tenantId}/${this.props.result.schoolCode}/process/${this.props.result.summary.secondInstanceId}`} target="_blank">
                        <CommandBarButton
                            iconProps={{ iconName: "OpenInNewTab" }}
                            text="Open second"
                        />
                    </Link>


                    <CommandBarButton
                        iconProps={{ iconName: "view" }}
                        text="View added"
                        onClick={() => {
                            this.setState({
                                showDifferences: false,
                                items: this.props.result.changes.itemsAddedToFirst,
                                itemsTitle: "Items added to first"
                            });
                        }}
                    />

                    <CommandBarButton
                        iconProps={{ iconName: "view" }}
                        text="View changed"
                        onClick={() => {
                            this.setState({
                                showDifferences: true,
                                items: undefined,
                                itemsTitle: undefined
                            });
                        }}
                    />

                    <CommandBarButton
                        iconProps={{ iconName: "view" }}
                        text="View removed"
                        onClick={() => {
                            this.setState({
                                showDifferences: false,
                                items: this.props.result.changes.itemsRemovedFromFirst,
                                itemsTitle: "Items removed from first"
                            });
                        }}
                    />

                    {this.props.children}
                </Table>

                {this.state.showDifferences ? <ProcessorDifferencesViewer changed={this.props.result.changes.itemsChanged}/> : null}

                {this.state.items ? <ProcessorItemsViewer minHeightForItems={"40rem"} title={this.state.itemsTitle} processorItems={this.state.items!} /> : null}
            </Fragment>
        );
    };
}